import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Loading: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default',
        gap: 2
      }}
    >
      <CircularProgress 
        size={60} 
        thickness={4}
        sx={{
          color: 'primary.main',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          }
        }}
      />
      <Typography 
        variant="h6" 
        color="text.secondary"
        sx={{ 
          fontWeight: 500,
          mt: 2
        }}
      >
        Carregando...
      </Typography>
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ 
          opacity: 0.7
        }}
      >
        Aguarde enquanto preparamos tudo para você
      </Typography>
    </Box>
  );
};

export default Loading;
